import { defineMessages } from "react-intl"

export const selectCatalogRoofColorMessages = defineMessages({
	code: {
		defaultMessage: "Code",
		id: "colors.roofColor.selectCatalogColorModal.container.view.code",
	},
	customColor: {
		defaultMessage: "Choose Custom Roof Color",
		id: "colors.exteriorColor.selectCatalogColorModal.container.view.customColor",
	},
	name: {
		defaultMessage: "Name",
		id: "colors.roofColor.selectCatalogColorModal.container.view.name",
	},
})
